import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useParams, useSearchParams } from 'react-router-dom';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import CarrierDetail, { CarrierReferrer } from '@app/pages/customer/carriers/carrier-detail/CarrierDetail.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

const CarrierDetailPage = () => {
  const { id } = useParams();
  const { tr } = useTranslationLgs();

  const [searchParams] = useSearchParams();
  const carrierReferrer = searchParams.get('carrierReferrer') as CarrierReferrer | null;

  return (
    <>
      {id && (
        <ResponsiveLayout title={tr(`CarrierDetailPage.CarrierDetail`, `Detail dopravce`)} oneOfPermission={[PermissionTypesEnum.PERMISSION_MY_CARRIERS_READ, PermissionTypesEnum.PERMISSION_MY_CARRIERS_RW]}>
          <CarrierDetail carrierId={id as string} carrierReferrer={carrierReferrer} />
        </ResponsiveLayout>
      )}
    </>
  );
};

export default withAuthenticationRequired(CarrierDetailPage);
